/* eslint-disable no-param-reassign */
import { Buffer } from "buffer";

import { WsClientSocket } from "./wsModule";

export type BufferLike =
    | string
    | Buffer
    | DataView
    | number
    | ArrayBufferView
    | Uint8Array
    | ArrayBuffer
    | SharedArrayBuffer
    | ReadonlyArray<any>
    | ReadonlyArray<number>
    | { valueOf(): ArrayBuffer }
    | { valueOf(): SharedArrayBuffer }
    | { valueOf(): Uint8Array }
    | { valueOf(): ReadonlyArray<number> }
    | { valueOf(): string }
    | { [Symbol.toPrimitive](hint: string): string };

export type ModifiedWebSocket = WsClientSocket & {
    sessionId: string;
};

export default function websocketModifier(
    websocket: WsClientSocket
): ModifiedWebSocket {
    // Пометить сокет полем sessionId (заполнится на handshake).
    const modifiedWebsocket: ModifiedWebSocket =
        websocket as unknown as ModifiedWebSocket;
    modifiedWebsocket.sessionId = null as unknown as string;
    if (typeof modifiedWebsocket.OPEN !== "number") {
        modifiedWebsocket.OPEN = 1;
    }

    return modifiedWebsocket;
}
